module.exports = __webpack_public_path__ + "static/media/inspect_reversed_white_circle_blue_m.8ac00b5c.png";